<template>
  <div class="instructions-page">
    <div v-if="!activeItem" class="instructions-page__main">
      <h1 class="instructions-page__title">
        Инструкции по работе в программе truck-telematics
      </h1>
      <div class="instructions-page__list">
        <div
          v-for="item in items"
          :key="item.section"
          class="instructions-page__item"
          @click="activeItem = item"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
    <div v-else class="instructions-page__detail">
      <div class="instructions-page__header">
        <h1 class="instructions-page__title">Инструкции по работе в программе truck-telematics. Раздел {{ activeItem.title }}.</h1>
        <button 
        @click="activeItem = null"
        class="dvs-info-modal-close">
          <img src="../../../public/images/button-exit.svg" style="width: 20px; height: 20px;" alt="✕">
        </button>
      </div>
      <div class="instructions-page__content">

        <div v-if="activeItem.section === 'statistics'">
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/statistics/Group1.png"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/statistics/Group2.png"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/statistics/Group3.png"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/statistics/Group4.png"
              alt=""
            />
          </div>
        </div>

        <div v-else-if="activeItem.section === 'monitoring'">
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/monitoring/Group1.jpg"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/monitoring/Group2.png"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/monitoring/Group3.png"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/monitoring/Group4.png"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/monitoring/Group5.png"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/monitoring/Group6.png"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/monitoring/Group7.png"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/monitoring/Group8.png"
              alt=""
            />
          </div>
          <div class="instruction-block">
            <img
              class="instruction-block__image"
              src="/images/guides/monitoring/Group9.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="last-block"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstructionsPage',
  data() {
    return {
      activeItem: null,
      items: [
        { title: 'Статистика', section: 'statistics' },
        { title: 'Мониторинг', section: 'monitoring' },
        { title: 'Отчеты', section: 'reports' },
        { title: 'Детализация', section: 'detail' },
        { title: 'Графики', section: 'graphics' },
        { title: 'Диагностика', section: 'diagnostics' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.instructions-page {
  width: 100%;
  height: calc(100vh - 37px);
  overflow: auto;
  // padding: 20px;
  box-sizing: border-box;
}

.instructions-page__title {
  font-size: 32px;
  font-weight: 900;
}

.instructions-page__list {
  margin-top: 20px;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.instructions-page__item {
  width: 175px;
  text-align: center;
  padding: 10px 40px;
  border: 1px solid #605dec;
  border-radius: 8px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f0f0ff;
  }
}

.instructions-page__main .instructions-page__title {
  margin: 0 20px;
}

.instructions-page__header {
  display: flex;
  position: sticky;
  background: white;
  top: 0;
  align-items: center;
  justify-content: space-between;
  margin: 0 20px;
}

.instructions-page__content {
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  // padding: 20px;
  margin: 20px;
  min-height: 300px;
}

.instruction-block {
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0;
  }
}

.instruction-block__image {
  width: 100%;
}
.last-block {
  margin-bottom: 60px;
}
.dvs-info-modal-close {
  display: inline-block;
  float: right;
  position: sticky;
  top: 0;
  z-index: 1;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  // display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
  transition: opacity 0.2s;
}
.dvs-info-modal-close:hover {
  opacity: 1;
}
</style>
